import { useEffect, useState } from 'react';
import { SalesOfficeEmployeeReportOrdering } from '../enum/ReportTableOrders';
import { setSalesOfficeEmployeeFilters } from '../../store/slices/reportsSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { salesOfficeEmployeeFiltersSelector } from '../../store/selectors/reportsSelectors';
import { salesOfficeEmployeeOrderingSelector } from '../../store/selectors/coreOrderingSelectors';
import { getSalesOfficeEmployeeReportOrderingThunk } from '../../store/thunks/core/coreOrderingThunks';
import { initPaging } from '../../core/types/coreTypes';

export const useSalesOfficeEmployeeDefaultOrdering = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(salesOfficeEmployeeFiltersSelector);
  const ordering = useAppSelector(salesOfficeEmployeeOrderingSelector);
  const [defaultOrder, setDefaultOrder] = useState<number | null>(null);

  useEffect(() => {
    ordering.length === 0 && dispatch(getSalesOfficeEmployeeReportOrderingThunk());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filters?.order?.field) {
      const defaultOrdering = ordering.find((el) => el.label === SalesOfficeEmployeeReportOrdering.CreationDate)?.value;
      if (defaultOrdering) {
        setDefaultOrder(defaultOrdering);
        dispatch(setSalesOfficeEmployeeFilters({ ...filters, order: { field: defaultOrdering, isAsc: false } }));
      }
    }
    // eslint-disable-next-line
  }, [ordering]);

  return {
    ...initPaging,
    order: defaultOrder ? { field: defaultOrder, isAsc: false } : filters?.order,
  };
};
